import React from 'react';
import { useAnimatedCounter } from '../../hooks';
import { statsData } from '../../data/siteData';

const StatItem = ({ stat }) => {
  const [ref, count] = useAnimatedCounter(stat.value, 2000);

  return (
    <div className="inline-flex items-center gap-4">
      <span ref={ref} className="font-gaming text-4xl md:text-5xl text-primary-500">
        {count}
        {stat.suffix}
      </span>
      <span className="text-gray-400 text-sm md:text-base">{stat.label}</span>
      <span className="text-primary-500">◆</span>
    </div>
  );
};

const StatsSection = () => {
  return (
    <section className="py-8 bg-gradient-to-r from-primary-500/10 via-secondary-400/10 to-primary-500/10 border-y border-white/10 overflow-hidden">
      <div className="animate-marquee whitespace-nowrap">
        <div className="inline-flex gap-16 px-8">
          {[...statsData, ...statsData].map((stat, i) => (
            <StatItem key={`${stat.id}-${i}`} stat={stat} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
